export default "__VITE_ASSET__C$$NRK95__"